import React, { useEffect, useState } from 'react';
import { Modal, Table } from 'antd';
import TestResultModal from './TestResultModal';
import {TestExecutionControllerApi, TestExecutionDto, TestExecutionDtoRunStatusEnum, TestResultDto} from '../../../api';
import {formatDateTime, renderStatusAmpel} from "../../../utils/Utils";
import {useKeycloakHeader} from "../../../config/Config";

/*
Dieses Modal zeigt alle Ausführungen eines Tests an
 */
const TestExecutionModal: React.FC<{ visible: boolean; testId: number; onClose: () => void }> = ({ visible, testId, onClose }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedTestResult, setSelectedTestResult] = useState<TestResultDto>();
    const [testExecutionData, setTestExecutionData] = useState<TestExecutionDto[]>();

    const headers = useKeycloakHeader();
    const testExecutionControllerApi = new TestExecutionControllerApi();

    useEffect(() => {
        testExecutionControllerApi.getTestRunsByTestId(testId, headers)
            .then((axiosResponse) => {
                const testRuns: Array<TestExecutionDto> = axiosResponse.data.map((testRun: TestExecutionDto) => ({
                    ...testRun,
                    startTs: formatDateTime(testRun.startTs),
                    endTs: formatDateTime(testRun.endTs),
                    resumeTs: formatDateTime(testRun.resumeTs),
                    steps: (testRun.result?.successfullSteps ?? 0)+ '/' + (testRun.result?.testSteps?.length ?? 0)
                }));
                setTestExecutionData(testRuns);
            })
            .catch((error) => {
                console.error('Fehler beim Abrufen der Daten:', error);
            });
    }, [testId, visible]);


    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Start',
            dataIndex: 'startTs',
            key: 'startTs',
        },
        {
            title: 'Ende',
            dataIndex: 'endTs',
            key: 'endTs',
            render: (text, record) => (
                <span>{!record.endTs && record.runStatus === TestExecutionDtoRunStatusEnum.Paused ? "Wird fortgesetzt: " + record.resumeTs : record.endTs}</span>
            ),
        },
        {
            title: 'Schritte',
            dataIndex: 'steps',
            key: 'steps',
        },
        {
            title: 'Status',
            dataIndex: 'runStatus',
            key: 'runStatus',
            width: '5%',
            render: (text, record) => (
                <span>{renderStatusAmpel(record.runStatus)}</span>
            ),
        },
    ];

    const handleRowClick = (record) => {
        setSelectedTestResult(record.result);
        setModalVisible(true);
    };

    return (
        <Modal
            title="Details der Testausführungen"
            open={visible}
            onCancel={onClose}
            footer={null}
            width={1000}
        >
            <Table
                dataSource={testExecutionData}
                columns={columns}
                onRow={(record) => ({
                    onClick: () => {
                        handleRowClick(record);
                    },
                })}
            />
            {selectedTestResult && (
                <TestResultModal visible={modalVisible} testResultId={selectedTestResult.id} onClose={() => setModalVisible(false)} />
            )}
        </Modal>
    );
};

export default TestExecutionModal;
